// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"e34bb3d5","540":"26829982"}[chunkId] + ".chunk.css";
};